var mask2 = "/static/cb2d7a44a72b511d.png";

export { mask2 as default };
//# sourceMappingURL=mask-2.png.js.map
